import React from 'react';
import { Outlet } from 'react-router-dom';

import { Loader, Blocker, useIsMobile } from '@neo.tax/shared';

import { useFiscalYearHomeRedirect } from './hooks';

export const FiscalYearHome = (): React.ReactElement => {
  const { isMobile } = useIsMobile();

  return (
    <Loader useRedirect={useFiscalYearHomeRedirect}>
      {isMobile && (
        <Blocker
          title="This screen size is too small"
          description="Neo.Tax requires a certain amount of screen space. If you're using a tablet, try rotating it to the landscape orientation, or try accessing Neo.Tax on a device with a larger screen."
        />
      )}
      <Outlet />
    </Loader>
  );
};
